const discoverES = {
	loading: "Cargando…",
	toolbar: {
		filters: "⚙︎ Filtros",
		sortBy: "Ordenar por:",
		showMap: "Ver Mapa",
		recommended: "Recomendado",
	},
	sort: {
		distance: "Distancia",
		highestRated: "Valoración",
		lowestRated: "Peor valoradas",
		recommended: "Recomendado"
	},
	title: "Tiendas",
	subtitle: "¿Qué afecta los resultados de búsqueda?",
	eyebrow: "Descubre",
	results: (count) => (count === 1 ? "1 lugar para reservar" : `${count} lugares para reservar`),
	updating: "Actualizando resultados…",
	loadMore: "Ver más",
	loadingMore: "Cargando más…",
	loadMoreError: "No pudimos cargar más — toca para reintentar.",
	showingOf: (shown, total) => `Mostrando ${shown} de ${total}`,
	reviews: "reseñas",
	shop: {
		untitled: "Tienda sin nombre",
	},
	card: {
		from: "Desde",
		home: "A domicilio",
		online: "En línea",
		viewShop: "Ver tienda",
		noPhoto: "Sin fotos aún",
	},
	services: {
		book: "Reservar",
		more: (count) => `+${count} servicios más`,
	},
	empty: "No se encontraron tiendas",
	emptyHint: "Todavía no hay nada de esta categoría cerca de ti. Prueba otra categoría o amplía el área en el mapa.",
	errorLoading: "No pudimos cargar los negocios. Inténtalo de nuevo.",
	errorHint: "Revisa tu conexión — los negocios se cargarán en cuanto vuelvas a estar en línea.",
	retry: "Reintentar",
	map: {
		eyebrow: "Explora el mapa",
		subtitle: "Elige un pin para ver un negocio, o navega las tarjetas de abajo.",
		listView: "Lista",
		updating: "Actualizando resultados…",
		viewShop: "Ver tienda",
		showOnMap: "Ver en el mapa",
		emptyHint: "Prueba mover el mapa o alejarlo para cubrir un área más amplia.",
		zoomIn: "Acercar",
		zoomOut: "Alejar",
		results: (count) => (count === 1 ? "1 resultado" : `${count} resultados`),
		filters: {
			open: "Filtros",
			close: "Cerrar filtros",
			title: "Filtrar resultados",
			subtitle: "Ajusta el mapa a lo que estás buscando.",
			searchLabel: "Busca servicios o negocios",
			searchPlaceholder: "Busca un servicio…",
			clearSearch: "Borrar búsqueda",
			category: "Categoría",
			subCategory: "Especialidad",
			serviceType: "Tipo de servicio",
			serviceTypes: { in_shop: "En el local", home: "A domicilio", online: "Online" },
			rating: "Valoración",
			all: "Todo",
			any: "Cualquiera",
			ratingOption: (value) => `${value}+`,
			reset: "Quitar filtros",
			apply: (count) => (count === 1 ? "Ver 1 resultado" : `Ver ${count} resultados`),
			noResults: "Sin coincidencias",
			emptyTitle: "Nada coincide con esos filtros",
			emptyHint: "Prueba quitar un filtro, buscar otro servicio o mover el mapa.",
		},
	},
};

export default discoverES;
